import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { StyledJumbotron } from '../../components/shared/jumbotron/jumbotron-styled';
import moment from 'moment';
import {
  BaSeTheme,
  BaSeContainer,
  BaSeDialogContext,
  BaSeDataTable,
  BaSeActionItem,
  BaSeInput,
  BaSeLoadingSpinner,
  BaSeHeading5,
  BaSeParagraph,
  BaSeBreakpointContext,
  BaSeDataList,
  BaSeCard,
  BaSeShapeButton,
  BaSeGrid,
  BaSeGridItem,
  BaSeSmall1,
  BaSeTag,
  BaSeCheckbox,
  BaSeHeading6,
} from '@base/react';
import {
  DataTableWrapper,
  PaddingContainer,
  ActionItemWrapper,
  NotFoundServiceContent,
  WrapperActions,
  ClientWrapper,
  CustomFilterContent,
} from './certificados-cliente-styled';
import {
  CERTIFICADOS_ENDPOINT,
  CERTIFICADOS_GRID_ENDPOINT,
  CERTIFICADO_ENDPOINT,
} from '../../hooks/constants';
import { ReactComponent as NotFoundItems } from '../../assets/services-not-found.svg';
import { Title } from '../../components/title/title';
import { DadosCertificado } from '../../components/dados-certificado/dados-certificado';
import { avaliableActions } from '../../models/actions';
import { DeleteText } from '../../components/delete/delete-text';
import {
  useCertificadosService,
  useTemplateCertificadoSasService,
} from '../../hooks/certificado';
import { Role } from '../../models/role';
import { ColumnFilter } from '../../components/data-table/column-filter';
import { ModalChangeValueCertificado } from '../../components/data-table/modal-change-certificado';

const listCheckboxReverse = {
  CPF: 'CPF',
  'Código SAS': 'CODIGO_SAS',
  'Nome do produto': 'NOME_PRODUTO',
};

const labelFilterActive = {
  CPF: 'CPF',
  CODIGO_SAS: 'Código SAS',
  NOME_PRODUTO: 'Nome do produto',
};

const typeSearch = {
  index: 0,
  type: 'CPF',
};

const listCheckbox = ['CPF', 'Código SAS', 'Nome do produto'];

// eslint-disable-next-line sonarjs/cognitive-complexity
export const CertificadosClientePage = () => {
  const [isSearch, setIsSearch] = React.useState(false);
  const { isAuthenticated, isInitialized } = Sebrae.useAuth();
  const { showNotification, showModal } = React.useContext(BaSeDialogContext);
  const [sendLoading, setSendLoading] = React.useState(false);
  const [copyLoading, setCopyLoading] = React.useState(false);
  const [idCertificado, setIdCertificado] = React.useState(0);
  const [clienteCpf, setClienteCpf] = React.useState('');
  const [searchText, setSearchText] = React.useState('');
  const [isListService, setIsListService] = React.useState(false);
  const [checkFilter, setCheckFilter] = React.useState(typeSearch);
  const [isClearFilter, setIsClearFilter] = React.useState(false);
  const [listModel, setListModels] = React.useState('');

  const { deleteSelectedItems, handleSendEmailCertificadosLote } =
    useCertificadosService();
  const { listTemplates } = useTemplateCertificadoSasService();

  const { backendPost, backendGet, backendDelete, backendPut } =
    Sebrae.useBackend();
  const { hasRoles } = Sebrae.useAuth();

  const { fetchData, data, loading, error } = Sebrae.usePagination(
    CERTIFICADOS_GRID_ENDPOINT,
  );

  const { onMobileSmall, onMobile, onMobileLarge } = React.useContext(
    BaSeBreakpointContext,
  );
  const { white } = BaSeTheme.colors.defaultColors;
  const {
    azulSebrae36,
    azulSebrae97,
    cinzaSebrae28,
    cinzaSebrae30,
    cinzaSebrae45,
    cinzaSebrae60,
  } = BaSeTheme.colors.institucionais;

  const isNotEmpty = React.useCallback((value) => {
    return !!value?.trim?.() ?? false;
  }, []);

  const isMobile = React.useCallback(
    () => onMobileSmall || onMobile || onMobileLarge,
    [onMobile, onMobileLarge, onMobileSmall],
  );

  React.useEffect(() => {
    if (data.total > 0) {
      setIsSearch(true);
    } else {
      setIsSearch(false);
    }
  }, [data.total]);

  React.useEffect(() => {
    if (error) {
      showNotification({
        message: error.message,
        color: 'destructive',
      });
    }
  }, [error, isInitialized, isAuthenticated, showNotification]);

  const modalConfigs = React.useCallback(
    (
      certificado,
      func,
      title,
      actions,
      content,
      size = 'large',
      isFluid = true,
      breakpointDelimiter = 'tablet',
    ) => ({
      size,
      title,
      actions,
      isFluid,
      breakpointDelimiter,
      onChooseAction: (action) => func?.(action, certificado),
      content: (onClose) => React.cloneElement(content, { onClose }),
    }),
    [],
  );

  const handleShowModal = React.useCallback(
    (id) => {
      return modalConfigs(
        null,
        null,
        'Dados do certificado',
        [],
        <DadosCertificado id={id} isShow />,
      );
    },
    [modalConfigs],
  );

  const handleUpdate = React.useCallback(
    (id) => async (params) => {
      try {
        await backendPut(`${CERTIFICADO_ENDPOINT}/${id}`, params);
        fetchData({ sort: { field: 'dataConclusao', type: 'DESC' } });
        return { sucess: true };
      } catch (e) {
        console.log(e);
        return { ...e };
      }
    },
    [backendPut, fetchData],
  );

  const handleUpdateModal = React.useCallback(
    (id) => {
      return modalConfigs(
        null,
        null,
        'Editar dados do certificado',
        [],
        <DadosCertificado
          id={id}
          notify={showNotification}
          isUpdate
          save={handleUpdate(id)}
          openModal={showModal}
        />,
      );
    },
    [handleUpdate, modalConfigs, showModal, showNotification],
  );

  const handleSendEmail = React.useCallback(
    (id) => {
      if (!id) {
        return;
      }

      setSendLoading(true);
      setIdCertificado(id);

      backendPost(`${CERTIFICADO_ENDPOINT}/${id}/email`)
        .then(() =>
          showNotification({
            message: 'Reenvio de e-mail ao cliente solicitado com sucesso!',
            color: 'confirmation',
          }),
        )
        .catch((error) =>
          showNotification({
            message:
              'Não foi possível realizar o envio do certificado por e-mail!',
            color: 'destructive',
          }),
        )
        .finally(() => setSendLoading(false));
    },
    [backendPost, showNotification],
  );

  const handleDeleteAction = React.useCallback(
    async (action, id) => {
      if (action === avaliableActions.confirmar) {
        try {
          await backendDelete(`${CERTIFICADO_ENDPOINT}/${id}`);
          showNotification({
            message: 'Registro excluído com sucesso!',
            color: 'confirmation',
          });
          fetchData({ sort: { field: 'dataConclusao', type: 'DESC' } });
          return { sucess: true };
        } catch (e) {
          console.log(e);
          return { ...e };
        }
      }
      return true;
    },
    [backendDelete, fetchData, showNotification],
  );

  const handleShowDeleteModal = React.useCallback(
    (id) => {
      const deleteDescription = [
        'Tem certeza que deseja excluir esse certificado?',
        'Não será possível recuperar.',
      ];
      return modalConfigs(
        id,
        handleDeleteAction,
        'Atenção!',
        [
          avaliableActions.confirmar,
          {
            action: avaliableActions.desistir,
            type: 'secondary',
            color: BaSeTheme.colors.institucionais.azulSebrae36,
          },
        ],
        <DeleteText texts={deleteDescription} />,
        'medium',
        false,
      );
    },
    [handleDeleteAction, modalConfigs],
  );

  const handleDeleteSelectedItemsAction = React.useCallback(
    async (
      action,
      selectedItems,
      isAllSelected,
      onSuccess,
      // eslint-disable-next-line sonarjs/cognitive-complexity
    ) => {
      if (action === avaliableActions.confirmar) {
        const idsCertificados = selectedItems.reduce((acc, { id }) => {
          acc.push(id);
          return acc;
        }, []);

        const paramsDelete = {
          loteDTO: {
            ids: isAllSelected ? null : idsCertificados,
            todos: isAllSelected,
          },
          filter: searchText,
          tipoBusca: checkFilter.type,
          listaModelos: listModel.toString(),
        };

        isAllSelected
          ? await deleteSelectedItems(
              paramsDelete,
              onSuccess,
              () => setSendLoading(false),
              clienteCpf,
              searchText,
            )
          : await deleteSelectedItems(
              paramsDelete,
              onSuccess,
              () => setSendLoading(false),
              clienteCpf,
              searchText,
            );
      }
      return true;
    },
    [checkFilter, clienteCpf, deleteSelectedItems, searchText, listModel],
  );

  const handleChangeValuesCertificado = React.useCallback(
    (selectedItems, isAllSelected, onSuccess, isTemplate) =>
      async (newValue) => {
        const idsCertificados = selectedItems.reduce((acc, { id }) => {
          acc.push(id);
          return acc;
        }, []);

        const paramsFilter = {
          loteDTO: {
            ids: isAllSelected ? null : idsCertificados,
            todos: isAllSelected,
          },
          nome: !isTemplate ? newValue : null,
          tipo: isTemplate ? newValue : null,
        };
        const query = `?filter=${searchText}&tipoBusca=${
          checkFilter.type
        }&listaModelos=${listModel.toString()}`;

        try {
          await backendPut(
            `${CERTIFICADO_ENDPOINT}/lote${query}`,
            paramsFilter,
          );
          onSuccess({ resetSelection: true });
          fetchData({ sort: { field: 'dataConclusao', type: 'DESC' } });
          return { sucess: true };
        } catch (e) {
          console.log(e);
          return { ...e };
        }
      },
    [backendPut, checkFilter.type, fetchData, listModel, searchText],
  );

  const handlesendEmailInLote = React.useCallback(
    async (selectedItems, isAllSelected, onSuccess) => {
      const idsCertificados = selectedItems.reduce((acc, { id }) => {
        acc.push(id);
        return acc;
      }, []);

      const paramsSendEmail = {
        loteDTO: {
          ids: isAllSelected ? null : idsCertificados,
          todos: isAllSelected,
        },
        filter: searchText,
        tipoBusca: checkFilter.type,
        listaModelos: listModel.toString(),
      };

      setSendLoading(true);
      handleSendEmailCertificadosLote(
        paramsSendEmail,
        onSuccess,
        setSendLoading,
      );
    },
    [checkFilter, handleSendEmailCertificadosLote, searchText, listModel],
  );

  const modalConfigDelete = React.useCallback(
    (
      selecteItems,
      allSelected,
      reloadData,
      func,
      title,
      actions,
      content,
      size,
      isChangeTemplate = false,
    ) => ({
      size,
      title,
      actions,
      beforeClose: (action) =>
        func?.(action, selecteItems, allSelected, reloadData, isChangeTemplate),
      content: (onClose) => React.cloneElement(content, { onClose }),
    }),
    [],
  );

  const handleDeleteSelectedItems = React.useCallback(
    (allSelected, selecteItems, reloadData) => {
      const pluralMessage = (selecteItems.length || data.total) > 1 ? 's' : '';

      const deleteDescription = [
        `Tem certeza que deseja excluir o${pluralMessage}${
          !!selecteItems.length
            ? pluralMessage === 's'
              ? ` ${selecteItems.length}`
              : ''
            : ` ${data.total}`
        } certificado${pluralMessage}?`,
        'Não será possível recuperar.',
      ];

      return modalConfigDelete(
        selecteItems,
        allSelected,
        reloadData,
        handleDeleteSelectedItemsAction,
        'Atenção!',
        [
          avaliableActions.confirmar,
          {
            action: avaliableActions.desistir,
            type: 'secondary',
            color: azulSebrae36,
          },
        ],
        <DeleteText texts={deleteDescription} />,
        'medium',
      );
    },
    [
      azulSebrae36,
      data.total,
      handleDeleteSelectedItemsAction,
      modalConfigDelete,
    ],
  );

  const handleActions = React.useCallback(
    (values, reloadData, isMobile) => {
      const actions = [];

      values?.url &&
        actions.push({
          text: 'Vizualizar certificado',
          icon: 'eye',
          color: cinzaSebrae45,
          callback: () => window.open(values.url),
        });

      hasRoles([Role.Administrador, Role.CertificadoDetalhar]) &&
        actions.push({
          text: 'Vizualizar dados do certificado',
          icon: 'eye',
          color: cinzaSebrae45,
          callback: () => showModal(handleShowModal(values.id)),
        });

      hasRoles([Role.Administrador, Role.CertificadoAlterar]) &&
        actions.push({
          text: 'Editar dados do certificado',
          icon: 'pen',
          color: cinzaSebrae45,
          callback: () => showModal(handleUpdateModal(values.id)),
        });

      values?.url &&
        actions.push({
          text: 'Copiar link',
          color: cinzaSebrae45,
          icon: 'copy',
          callback: () => {
            navigator.clipboard.writeText(values.url);
            showNotification({
              message: 'Dados copiados para a área de transferência!',
              color: 'confirmation',
              secondsToClose: 2,
            });
          },
        });

      hasRoles([Role.Administrador, Role.CertificadoEnvioEmail]) &&
        actions.push({
          text: 'Reenviar e-mail ao cliente',
          icon: 'envelope-upload',
          color: cinzaSebrae45,
          callback: () => handleSendEmail(values.id),
        });

      hasRoles([Role.Administrador, Role.CertificadoExcluir]) &&
        actions.push({
          text: 'Excluir certificado',
          icon: 'trash-alt',
          color: cinzaSebrae45,
          callback: () => showModal(handleShowDeleteModal(values.id)),
        });

      return !isMobile ? (
        <>
          {!!actions.length && (
            <BaSeActionItem
              closeOnAction
              icon="ellipsis-v"
              position="bottom-right"
              size="small"
              minWidth="230px"
              items={actions}
            />
          )}
        </>
      ) : (
        actions
      );
    },
    [
      cinzaSebrae45,
      handleSendEmail,
      handleShowDeleteModal,
      handleShowModal,
      handleUpdateModal,
      hasRoles,
      showModal,
      showNotification,
    ],
  );

  const handleSearchType = React.useCallback(
    (setFilter, setTags, resetSelection, checked) => {
      if (!isNotEmpty(searchText) || checkFilter.index === undefined) return;
      resetSelection();
      const { index } = checked;
      const isTypeCpf = index === 0;
      setIsClearFilter(false);

      if (checked.index >= 0) {
        setIsListService(true);
        setFilter((actualFilter) => {
          const filter = {
            tipoBusca: checked.type,
            sortField: 'dataConclusao',
            sortType: 'DESC',
            filter: isTypeCpf
              ? searchText.replace(/\D/g, '')
              : searchText ?? undefined,
          };

          return { ...actualFilter, ...filter };
        });
        setTags((tagsActive) => {
          return [
            ...tagsActive.filter((tag) => {
              const { label } = tag;
              return (
                !label.startsWith('CPF') &&
                !label.startsWith('Cód') &&
                !label.startsWith('Nom')
              );
            }),
            {
              label: `${labelFilterActive[checked.type]}: ${searchText}`,
              onClose: () => {
                setTags((tags) => {
                  const tagsFiltered = [
                    ...tags.filter(
                      (tag) =>
                        !tag?.label?.startsWith(
                          labelFilterActive[checked.type],
                        ),
                    ),
                  ];
                  setIsClearFilter(!tagsFiltered.length);
                  return tagsFiltered;
                });
                fetchData({
                  filter: {
                    tipoBusca: undefined,
                    filter: undefined,
                    cpf: undefined,
                  },
                  sort: { type: 'DESC', field: 'dataConclusao' },
                });
                resetSelection();
              },
            },
          ];
        });
      }
    },
    [checkFilter, fetchData, isNotEmpty, searchText],
  );

  const args = React.useMemo(
    () => ({
      columnConfig: [
        {
          columnId: 'id',
          stickyOnCompactMode: true,
        },
        {
          columnId: 'tipo',
          columnFilterIconProps: { shape: 'square' },
          width: 200,
          renderColumnFilter: ({
            setFilter,
            setTags,
            closeFilter,
            resetSelection,
          }) => (
            <ColumnFilter
              columnId="tipo"
              setFilter={setFilter}
              setTags={setTags}
              closeFilter={closeFilter}
              resetSelection={resetSelection}
              items={listTemplates}
              fetchData={fetchData}
              isSearchFor={checkFilter.index >= 0 && !!searchText.length}
              setIsClearFilter={setIsClearFilter}
              setListModels={setListModels}
            />
          ),
        },
      ],
      config: [
        {
          accessorKey: 'codigoProduto',
          header: 'Código do SAS',
        },
        {
          accessorKey: 'nomeProduto',
          header: 'Produto',
          mapper: ({ values: { nomeProduto } }) => {
            return nomeProduto ?? '-';
          },
        },
        {
          accessorKey: 'tipoProduto',
          header: 'Tipo',
          mapper: ({ values: { tipoProduto } }) => {
            return tipoProduto ?? '-';
          },
        },
        {
          accessorKey: 'tipo',
          header: 'Template',
        },
        {
          accessorKey: 'cargaHoraria',
          header: 'Carga Horária',
        },
        {
          accessorKey: 'dataConclusao',
          header: 'Data da conclusão',
          mapper: ({ values: { dataConclusao } }) => {
            return moment(dataConclusao).format('DD/MM/YYYY');
          },
        },
        {
          header: 'Ações',
          mapper: ({ values, reloadData }) => (
            <ActionItemWrapper>
              {sendLoading && values.id === idCertificado ? (
                <BaSeLoadingSpinner
                  color="default"
                  description="Carregando…"
                  diameter={25}
                  type="tertiary"
                />
              ) : (
                handleActions(values, reloadData)
              )}
            </ActionItemWrapper>
          ),
        },
      ],
      customFilterIconVisible: false,
      backgroundColor: white,
      hasPagination: true,
      hasSorting: true,
      initialPageIndex: 0,
      initialPageSize: 10,
      initialSortField: 'dataConclusao',
      initialSortType: 'DESC',
      isLoading: isClearFilter ? false : loading,
      items: isClearFilter ? [] : data.items,
      total: isClearFilter ? 0 : data.total,
      itemsPerPage: [10, 20, 50],
    }),
    [
      checkFilter,
      data,
      fetchData,
      handleActions,
      idCertificado,
      isClearFilter,
      listTemplates,
      loading,
      searchText,
      sendLoading,
      white,
    ],
  );

  const Small = ({ value }) => (
    <BaSeSmall1 color={cinzaSebrae28}>{value}</BaSeSmall1>
  );
  const BodyClient = ({ title, value, isStatus }) => {
    return (
      <ClientWrapper isStatus={isStatus}>
        <BaSeSmall1 color={cinzaSebrae30}>{title}</BaSeSmall1>
        {!isStatus && <Small value={value} />}
      </ClientWrapper>
    );
  };

  const ActionsCard = ({ value, reloadData }) => (
    <WrapperActions>
      {!!handleActions(value, reloadData, true).length &&
        handleActions(value, reloadData, true).map((action) => (
          <BaSeShapeButton
            color={cinzaSebrae60}
            type="tertiary"
            shape="circle"
            size="small"
            sizeIcon="medium"
            nameIcon={action.icon}
            onClick={action.callback}
          />
        ))}
    </WrapperActions>
  );

  const handleCard = (values, reloadData) => {
    return (
      <>
        <BaSeCard
          disposition="stacked"
          elevationOnHoverOrFocus
          renderContentAction={() => (
            <ActionsCard value={values} reloadData={reloadData} />
          )}
          width="100%"
          destakColor="default"
          withSideDestak={false}
          renderContentInfo={() => (
            <div>
              <BaSeGrid>
                <BaSeGridItem desktop={{ size: 12 }}>
                  <BaSeTag
                    color={BaSeTheme.colors.feedbackInterface.sucesso20}
                    label="Gerado"
                  />
                </BaSeGridItem>
                <BaSeGridItem desktop={{ size: 12 }}>
                  <BodyClient
                    title={'Código do SaS:'}
                    value={values?.codigoProduto ?? '-'}
                  />
                  <BodyClient
                    title={'Produto:'}
                    value={values?.nomeProduto ?? '-'}
                  />
                  <BodyClient
                    title={'Tipo:'}
                    value={values?.tipoProduto ?? '-'}
                  />
                  <BodyClient
                    title={'Carga horária:'}
                    value={values?.cargaHoraria ?? '-'}
                  />
                  <BodyClient
                    title={'Data de conclusão:'}
                    value={
                      values?.dataConclusao
                        ? moment(values?.dataConclusao).format('DD/MM/YYYY')
                        : '-'
                    }
                  />
                </BaSeGridItem>
              </BaSeGrid>
            </div>
          )}
        />
      </>
    );
  };

  const NotFound = () => (
    <NotFoundServiceContent>
      <NotFoundItems />
      <BaSeHeading5 isBold color={cinzaSebrae30}>
        Nenhum registro encontrado.
      </BaSeHeading5>
      <BaSeParagraph color={cinzaSebrae30}>
        Realize a busca pelo CPF, Código SAS ou Nome do produto
      </BaSeParagraph>
    </NotFoundServiceContent>
  );

  const modalActionChange = React.useCallback(
    (allSelected, selectedItems, reloadData, isChangeTemplate, func) => {
      const titleModal = isChangeTemplate
        ? 'Alterar template dos certificados'
        : 'Alterar nome do cliente';

      return modalConfigs(
        null,
        null,
        titleModal,
        [],
        <ModalChangeValueCertificado
          openModal={showModal}
          notify={showNotification}
          save={handleChangeValuesCertificado(
            selectedItems,
            allSelected,
            reloadData,
            isChangeTemplate,
          )}
          isChangeTemplate={isChangeTemplate}
          listTemplates={listTemplates}
          cpf={searchText}
        />,
        'medium',
        false,
      );
    },
    [
      handleChangeValuesCertificado,
      listTemplates,
      modalConfigs,
      showModal,
      showNotification,
      searchText,
    ],
  );

  const copyLinks = React.useCallback(
    (itemsCertificado, isAllSelected, reloadData) => {
      const links = itemsCertificado.map((e) => {
        return `${
          isAllSelected ? e.nomeCurso : e.nomeProduto
        } - Data conclusão: ${
          isAllSelected
            ? e.dataFim
            : moment(e.dataConclusao).format('DD/MM/YYYY')
        } \n${e?.url ?? '-'} \n\n`;
      });
      navigator.clipboard.writeText(links.toString().replace(/,/g, ''));
      reloadData({ resetSelection: true });
      setCopyLoading(false);
      return showNotification({
        message: 'Links copiados',
        supportMessage:
          'A lista de links foi copiada e está na área de transferência',
        color: 'confirmation',
        secondsToClose: 5,
      });
    },
    [showNotification],
  );

  const handleCopyAll = React.useCallback(
    (isAllSelected, selectedItems, reloadData) => {
      setCopyLoading(true);
      if (isAllSelected) {
        const query = `?filter=${searchText}&tipoBusca=${
          checkFilter.type
        }&listaModelos=${listModel.toString()}`;

        backendGet(`${CERTIFICADOS_ENDPOINT}/lote/links${query}`)
          .then((data) => {
            copyLinks(data, isAllSelected, reloadData);
          })
          .catch((error) => {
            showNotification({
              message: 'Não foi possível copiar todos os links!',
              supportMessage: error.message,
              color: 'destructive',
            });
            setCopyLoading(false);
          });
      } else {
        copyLinks(selectedItems, isAllSelected, reloadData);
      }
    },
    [
      backendGet,
      checkFilter,
      copyLinks,
      listModel,
      searchText,
      showNotification,
    ],
  );

  const actionInLot = React.useCallback(
    (isAllSelected, selectedItems, reloadData) => {
      const args = {
        color: cinzaSebrae60,
        type: 'tertiary',
        isLoading: sendLoading,
      };

      const actions = [
        {
          value: 'Reenviar e-mail',
          ...args,
          leftIcon: 'envelope-upload',
          isLoading: sendLoading,
          onClick: () =>
            handlesendEmailInLote(selectedItems, isAllSelected, reloadData),
        },
        {
          value: 'Alterar template',
          ...args,
          leftIcon: 'image-edit',
          onClick: () => {
            showModal(
              modalActionChange(
                isAllSelected,
                selectedItems,
                reloadData,
                true,
                handleChangeValuesCertificado,
              ),
            );
          },
        },

        {
          ...args,
          value: 'Excluir',
          leftIcon: 'trash-alt',
          onClick: () => {
            showModal(
              handleDeleteSelectedItems(
                isAllSelected,
                selectedItems,
                reloadData,
              ),
            );
          },
        },
      ];

      if (checkFilter?.index === 0 && searchText.length > 13) {
        actions.unshift({
          ...args,
          value: 'Alterar nome',
          leftIcon: 'edit-alt',
          onClick: () => {
            showModal(
              modalActionChange(
                isAllSelected,
                selectedItems,
                reloadData,
                false,
                handleChangeValuesCertificado,
              ),
            );
          },
        });
        actions.splice(3, 0, {
          value: 'Copiar links',
          ...args,
          leftIcon: 'copy',
          isLoading: copyLoading,
          onClick: () =>
            handleCopyAll(isAllSelected, selectedItems, reloadData),
        });
      }
      return actions;
    },
    [
      checkFilter,
      cinzaSebrae60,
      handleChangeValuesCertificado,
      handleCopyAll,
      handleDeleteSelectedItems,
      handlesendEmailInLote,
      modalActionChange,
      searchText.length,
      sendLoading,
      showModal,
      copyLoading,
    ],
  );

  React.useEffect(() => {
    if (checkFilter.type === 'CPF') {
      setClienteCpf(searchText);
    }
  }, [checkFilter, searchText]);

  const customFilter = React.useCallback(
    (setFilter, setTags, resetSelection) => {
      const placehoderFilter =
        listCheckbox?.[checkFilter.index] ?? 'Pesquise aqui..';
      return (
        <CustomFilterContent>
          <BaSeHeading6 color={cinzaSebrae45}>Buscar por:</BaSeHeading6>
          <div style={{ display: 'flex', gap: 8 }}>
            {listCheckbox.map((option, i) => (
              <div key={i} style={{ margin: '16px 0' }}>
                <BaSeCheckbox
                  label={option}
                  checked={i === checkFilter.index}
                  onChange={() => {
                    const checked = {
                      index: i,
                      type: listCheckboxReverse[option],
                    };
                    setCheckFilter(checked);
                    setSearchText('');
                  }}
                  shape="circle"
                />
              </div>
            ))}
          </div>
          <BaSeInput
            align="start"
            color="default"
            inputMode="search"
            mask={checkFilter.type === 'CPF' ? 'cpf' : ''}
            iconButton={{
              action: () => {
                handleSearchType(
                  setFilter,
                  setTags,
                  resetSelection,
                  checkFilter,
                );
              },
              name: 'search',
              color: azulSebrae36,
              typeButton: 'base-icon',
              type: 'secondary',
            }}
            onSpecificKeyDown={[
              {
                listenerKey: 'Enter',
                callback: () => {
                  handleSearchType(
                    setFilter,
                    setTags,
                    resetSelection,
                    checkFilter,
                  );
                },
              },
            ]}
            onChange={(term) => {
              setSearchText(term);
            }}
            placeholder={
              checkFilter.type === 'CPF' ? '000.000.000-00' : placehoderFilter
            }
            size="medium"
            typeInput="text"
            value={searchText}
            width={!isMobile() ? '250px' : '100%'}
          />
        </CustomFilterContent>
      );
    },
    [
      azulSebrae36,
      checkFilter,
      cinzaSebrae45,
      handleSearchType,
      isMobile,
      searchText,
    ],
  );

  const handleOnClearFilter = React.useCallback(() => {
    setIsClearFilter(true);
    fetchData({
      sort: { field: undefined, type: 'DESC' },
      filter: {
        filter: undefined,
        tipoBusca: undefined,
        cpf: undefined,
        listaModelos: undefined,
      },
    });
    setCheckFilter(typeSearch);
    setSearchText('');
    setIsListService(false);
    setListModels('');
  }, [fetchData]);

  return (
    <div>
      {!isMobile() ? (
        <StyledJumbotron backgroundColor={azulSebrae97}>
          <div>
            <Title
              titulo="Certificados Sebrae"
              subtitulo="Certificados do Cliente"
              paddingContent="16px"
              paddingSubtitulo="16px"
            />
          </div>
        </StyledJumbotron>
      ) : (
        <div style={{ margin: '16px 10px' }}>
          <BaSeHeading5 color={cinzaSebrae45}>
            Listagem de certificados
          </BaSeHeading5>
        </div>
      )}
      <BaSeContainer delimitedOnBreakpoint="desktop">
        <PaddingContainer>
          <DataTableWrapper
            isDesktop={!isMobile()}
            isSearch={isSearch}
            noItems={data.total === 0 || isClearFilter}
          >
            {!isMobile() ? (
              <div>
                <BaSeDataTable
                  {...args}
                  hasCustomFilter
                  customFilterVisible
                  customFilterTitle=""
                  filterAreaBackgroundColor={white}
                  onClearFilter={({ resetSelection }) => {
                    resetSelection()
                    handleOnClearFilter();
                  }}
                  renderCustomFilter={({
                    setFilter,
                    setTags,
                    resetSelection,
                  }) => customFilter(setFilter, setTags, resetSelection)}
                  selectionButtonActions={({
                    isAllSelected,
                    selectedItems,
                    reloadData,
                  }) => [
                    ...(!!selectedItems.length &&
                    hasRoles([
                      Role.CertificadoReprocessar,
                      Role.CertificadoReprocessarErros,
                      Role.Administrador,
                    ])
                      ? actionInLot(isAllSelected, selectedItems, reloadData)
                      : isAllSelected &&
                        hasRoles([
                          Role.CertificadoReprocessar,
                          Role.CertificadoReprocessarErros,
                          Role.Administrador,
                        ]) &&
                        actionInLot(isAllSelected, selectedItems, reloadData)),
                  ]}
                  fetchData={
                    isListService ? fetchData : function noRefCheck() {}
                  }
                  title="Certificados existentes para o CPF"
                  titleColor={cinzaSebrae45}
                  hasSelection={hasRoles([
                    Role.CertificadoReprocessar,
                    Role.CertificadoReprocessarErros,
                    Role.Administrador,
                  ])}
                  notFoundMessage={
                    !loading || isClearFilter ? <NotFound /> : ''
                  }
                />
              </div>
            ) : (
              <BaSeDataList
                fetchData={isListService ? fetchData : function noRefCheck() {}}
                hasCustomFilter
                customFilterVisible
                customFilterTitle=""
                onClearFilter={handleOnClearFilter}
                renderCustomFilter={({ setFilter, setTags, closeFilter }) =>
                  customFilter(setFilter, setTags, closeFilter)
                }
                total={isClearFilter ? 0 : data.total}
                isLoading={isClearFilter ? false : loading}
                items={isClearFilter ? [] : data.items}
                initialPageIndex={0}
                initialPageSize={10}
                itemsPerPage={[10, 20, 50]}
                densityLevel="normal"
                genderOfItemDescription="male"
                pluralItemDescription="itens"
                singularItemDescription="item"
                initialSortField="dataConclusao"
                initialSortType="DESC"
                renderCard={({ values, reloadData }) =>
                  handleCard(values, reloadData)
                }
                filterAreaBackgroundColor={white}
                notFoundMessage="Sem itens para exibir"
                hasSorting
                hasPagination
                compactMode
                hasHeader={false}
                renderNotFoundContent={() => <NotFound />}
              />
            )}
          </DataTableWrapper>
        </PaddingContainer>
      </BaSeContainer>
    </div>
  );
};
